module.exports = __webpack_public_path__ + "static/media/kp.9c534291.svg";